import React from 'react';
import { useLocation } from 'react-router-dom';

import EventsList from '../../components/member/events/events-list';

import './member-nav-style.css';

function MemberNav() {
  const location = useLocation();

  if (location.pathname.indexOf('/direct') === 0) {
    return null;
  }

  return (
    <div className="member-footer align-items-center justify-content-center">
      <EventsList />
    </div>
  );
}

export default MemberNav;
